import React,{useState} from 'react'
import ShopHeader from './ShopHeader'
import { setData } from './Med';


const Foods = () => {

    const [count, setCount] = useState(0);
 
    const add =(obj)=>{
        setData(obj)
        setCount(count+1);
    }
  

    return (
        <>
            <ShopHeader cartcount={count}/>
          <i><h1 className='h1t'>FOOD ITEMS</h1></i>

            <div className='row'>
                {itemData.map((items,index)=>{return(

                <div class="card cardstyle">
                    <img class="card-img-top mt-2" src={items.img} alt="Card  cap" />
                    <div class="card-body">
                        <h5 class="card-title">{items.title}</h5>
                        <button onClick={()=>add(items)} class="btn btn-primary">Add to Cart</button>
                    </div>
                </div>
                )})}

            </div>
        </>
    )
}
const itemData = [
    {
        img: 'https://images.unsplash.com/photo-1551963831-b3b1ca40c98e',
        title: 'Breakfast',
        rows: 2,
        cols: 2,
        featured: true,
    },
    {
        img: 'https://images.unsplash.com/photo-1551782450-a2132b4ba21d',
        title: 'Burger',
    },
    {
        img: 'https://images.unsplash.com/photo-1444418776041-9c7e33cc5a9c',
        title: 'Coffee',
        cols: 2,
    },
    {
        img: 'https://images.unsplash.com/photo-1558642452-9d2a7deb7f62',
        title: 'Honey',
        rows: 2,
        cols: 2,
        featured: true,
    },
    
];

export default Foods;